'use client';

import { BoxButton, Description, InfoView } from '@repo/ui';
import { useSetAtom } from 'jotai';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

import { LogoLayout } from '@/app/_components/layout-content/Layouts';
import { useCheckHeaderShow } from '@/lib/hooks/use-platform';
import { contentsAtom } from '@/lib/stores/home';

export const GlobalErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();
  return (
    <ErrorBoundary key={pathname} FallbackComponent={DefaultFallbackComponent}>
      {children}
    </ErrorBoundary>
  );
};

export const DefaultFallbackComponent = ({ error }: FallbackProps) => {
  const errorMessage = (error as Error).message;
  const isShowHeader = useCheckHeaderShow();
  const setContents = useSetAtom(contentsAtom);

  return (
    <LogoLayout isUseHeader={isShowHeader} isUseInformationUse={false} isUseIntroduce={false} isUseAppMenu={true} isUseShare={false}>
      <InfoView
        description={
          <Description
            size={'medium'}
            graphic={
              <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/icg_laptop-question-mark_lg.svg`} width={88} height={88} alt="Not Found Icon" />
            }
            title={'에러가 발생했어요'}
            description={errorMessage ?? '알 수 없는 에러가 발생했어요. 잠시 후 다시 시도해주세요.'}
            button={
              <Link href={'/'}>
                <BoxButton
                  variant={'filled-primary'}
                  size={'medium'}
                  onClick={() => {
                    setContents({ currentPage: 1, cardItems: [] });
                  }}
                >
                  홈으로 돌아가기
                </BoxButton>
              </Link>
            }
          />
        }
      />
    </LogoLayout>
  );
};
